import { createContext } from "react";
import { CadastroDTO, LoginDTO, Usuario } from "./AuthProps";

interface AuthContextType {
  usuario: Usuario | null;
  cliente: Usuario | null;
  token: string | null;
  loading: boolean;

  loginCliente: (data: LoginDTO) => Promise<void>;
  logoutCliente: () => void;
  tokenCliente: string | null;

  login: (data: LoginDTO) => Promise<boolean>;
  cadastrar: (data: CadastroDTO) => Promise<void>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType>({
  usuario: null,
  token: null,
  loading: true,
  cliente: null,
  loginCliente: async () => {},
  logoutCliente: () => {},
  tokenCliente: null,
  login: async () => false,
  cadastrar: async () => {},
  logout: () => {}
});